import { Text } from "@clipboard-health/ui-components";
import { CircularProgress, Stack } from "@mui/material";

export function NewsFeedLoadingMoreState() {
  return (
    <Stack spacing={2} justifyContent="center" alignItems="center">
      <CircularProgress />
      <Text>Loading more news...</Text>
    </Stack>
  );
}
